import { TObjectFilterValue } from 'common/types';
import {
    IBasicFileFragment,
    ICertificateTypeListItemFragment,
    ICreateSkillInput,
} from 'graphql/types';
import { TGroupListItem } from 'user/types';

export type TSkillOption = {
    id: string;
    name: string;
};

export interface ISkillGroupRequirement {
    group: TGroupListItem;
    minAbsolute?: number | null;
    minPercent?: number | null;
}

export type TSkillFormCertificate = ICertificateTypeListItemFragment & {
    isMandatory?: boolean;
};

export type TSkillFormValues = Omit<
    ICreateSkillInput,
    'groups' | 'certificates' | 'thumbnailId'
> & {
    groups?: ISkillGroupRequirement[];
    certificates?: TSkillFormCertificate[];
    thumbnail?: IBasicFileFragment;
};

export interface ISkillFilterValues {
    skillGroups: TObjectFilterValue[];
}

export enum ESkillCertificateOfferEventDialogMode {
    Enrollment = 'enrollment',
    Notify = 'notify',
}
